module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/main-70631d2ad4ba0b9242aee3e0d565a086.svg";